import React, { useReducer } from 'react';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import styled from 'styled-components';
import { handleZoom, handleLeave, handleInit, zoomReducer } from '../helpers';

export const MainImage = ({ selectedImage, handleClick, alt }) => {
  const [state, dispatch] = useReducer(zoomReducer, { lens: { x: 0, y: 0 }, zoom: {} });
  const backgroundPosition = `-${state.zoom.x}px -${state.zoom.y}px`;

  return (
    <>
      <Container
        onMouseMove={handleZoom(dispatch, state)}
        onMouseLeave={handleLeave(dispatch)}
        onMouseEnter={handleInit(dispatch)}
        onClick={handleClick}
      >
        {state.active && <Lens style={{ top: state.lens.y, left: state.lens.x }} />}
        <LazyPicture sources={{ desktop: { src: selectedImage.main, ratio: '1:1' } }} alt={alt} />
      </Container>
      {state.active && <Zoom style={{ backgroundPosition }} $src={selectedImage.zoom} />}
    </>
  );
};

const Lens = styled.div`
  background: rgba(0, 0, 0, 0.5);
  width: 240px;
  height: 240px;
  position: absolute;
  z-index: 30;
`;

const Container = styled.div`
  width: 400px;
  height: 400px;
  cursor: zoom-in;
`;

const Zoom = styled.div`
  background: #ddd;
  background-image: url(${({ $src }) => $src});
  background-size: 1000px 1000px;
  width: 600px;
  height: 600px;
  position: absolute;
  top: -82px;
  left: 100%;
  z-index: 20;
  border: 1px solid #f1f1f1;
`;

export default MainImage;
